// @ts-nocheck
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  forwardRef,
} from '@angular/core';
import { isEmpty as isEmptyRamda } from 'ramda';
import { finalize } from 'rxjs/operators';
import { CurAwait } from '../../../../../../helpers/_old_helpers/curAwaitClass';
import { InputCheckboxComponent } from '../../../../fields/input-checkbox/input-checkbox.component';
import { InputRadioComponent } from '../../../../fields/input-radio/input-radio.component';
import { ListReferenceComponent } from '../../../../fields/list-reference/list-reference.component';
import { SelectCondensedComponent } from '../../../../fields/select-condensed/select-condensed.component';
import { SelectComponent } from '../../../../fields/select/select.component';
import { TableFieldComponent } from '../../../../fields/table/table.component';
import { DynamicFormService } from '../../../dynamic-form.service';
import { FormTemplateService } from '../../form-template/form-template.service';

@Component({
  selector: 'lbca-entity-fields',
  templateUrl: './entity-fields.component.html',
  styleUrl: './entity-fields.component.scss',
  imports: [
    ListReferenceComponent,
    SelectComponent,
    SelectCondensedComponent,
    InputRadioComponent,
    InputCheckboxComponent,
    forwardRef(() => TableFieldComponent),
  ],
})
export class EntityFieldsComponent extends CurAwait implements OnChanges, OnInit, OnDestroy {
  public labelValue = '';
  public helperTextValue = '';
  public isRequired = false;
  public isDisabled = false;
  public isReadOnly = false;
  public field!: any;
  public options: any[] = [];
  public dataTable: any[] = [];
  public isSearch = false;
  public isLabeled = true;
  public isTabeled = false;
  public isEditable = false;
  public isInline = false;
  public valueInput: any = null;
  public error: any[] = [];
  private initialized!: boolean;

  private exclusionIdsList: any[] = [];

  private getIntervalOptions: any = null;

  public searchFilter: any[] = [];
  public pageSelected = 0;
  public totalPages = 0;

  public callDynamicForm = new EventEmitter();

  public loading = false;

  public typeForced = '';

  public loadingAnimation = false;

  private optionsParams = {};
  private father;
  private lastFatherValue = {};
  public cardInfo: any;
  public excludeItens: any[] = [];

  constructor(
    private formTemplateService: FormTemplateService,
    private dynamicFormService: DynamicFormService
  ) {
    super();
  }

  public setInitialValue!: string;

  @Input() set initialValue(iv: string) {
    this.setInitialValue = iv;
  }

  @Input('loading') set loadingValue(value: boolean) {
    this.loadingAnimation = value;
  }

  @Input() set require(status: boolean) {
    this.isRequired = status;
  }
  @Input() set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }

  public flowId;
  @Input('flowId') set flow(id) {
    this.flowId = id;
  }

  @Input() set readOnly(readOnly: boolean) {
    this.isReadOnly = readOnly;
  }

  @Input() set helperText(value: string) {
    this.helperTextValue = value;
  }

  @Input() set label(value: string) {
    this.labelValue = value;
  }
  @Input() set forceType(value: string) {
    if (value) this.typeForced = value;
  }
  @Input() set labeled(value: boolean) {
    this.isLabeled = value;
  }
  @Input() set editable(value: boolean) {
    this.isEditable = value;
  }
  @Input() set tabeled(value: boolean) {
    this.isTabeled = value;
  }
  @Input() set inline(value: boolean) {
    this.isInline = value;
  }
  @Input() set cardData(data) {
    this.cardInfo = data;
  }
  @Input() set removeItens(itens) {
    this.excludeItens = itens;
  }

  @Input('field')
  set fieldProperties(field: any) {
    this.field = field;
    setTimeout(() => this.getOptions(), 10);
  }

  @Input('initialized') set setInitialized(initialized: boolean) {
    if (this.initialized !== undefined && this.initialized !== initialized) {
      this.getOptions();
    }
    this.initialized = initialized;
  }

  @Input('error')
  set err(error) {
    this.error = error;
  }

  public setError(err) {
    this.setErrorEmmiter.emit(err);
  }

  public changeLabelValue($event) {
    this.changeLabelEmmiter.emit($event);
  }

  public changeValue($event) {
    this.changeEmmiter.emit($event);
  }

  public startValue($event) {
    this.startValueEmmiter.emit($event);
  }

  public focusState($event) {
    this.focusStateEmmiter.emit($event);
  }

  @Input() set defaultValue(defaultValue) {
    this.valueInput = defaultValue;

    // se tirar esse timeout quebra o "Endereço de cumprimento é presencial?" em diligencia
    setTimeout(() => {
      this.changeValue(defaultValue);
    }, 1000);
  }

  @Input()
  /**Alterado o if pois o objeto nao devolve o valor undefined e sim null, estava bugando
   * o modulo de pedidos
   * [Iago] => Implementação do <vall === false> no if para o componente input-radio poder interpretar o valor 'false'
   */
  set value(val: any) {
    if (
      typeof val === 'undefined' ||
      (typeof val === 'object' && Object.keys(val || {}).length === 0)
    )
      return;

    let exclusion = val;
    if (val.data) exclusion = val.data;
    if (this.exclusionIdsList !== exclusion && this.exclusionIdsList.length !== exclusion.length) {
      this.exclusionIdsList = exclusion;
      setTimeout(
        () =>
          this.processInputValue(val).then((value) => {
            if (val.data) {
              this.valueInput = {
                primary: val.primary,
                data: value,
              };
            } else {
              if (value === null) {
                this.valueInput = [];
                this.changeValue(this.valueInput);
              }
              this.valueInput = value;
            }
            this.getOptions();
          }),
        100
      );
    } else {
      this.valueInput = val; // else adicionado pois estava ignorando alterações de dependency select
    }
  }

  @Input('isOpen')
  set setIsOpen(isOpen) {
    this.error = isOpen;
  }

  @Input('dataFather')
  set fatherProp(val: any) {
    if (val) {
      this.father = val;
    }
  }

  @Input()
  set controllData(dataActual: any) {
    if (this.father && dataActual) {
      this.father.forEach((dad) => {
        const fatherValue = dataActual.value;

        if (this.lastFatherValue[dad.fieldKey] != fatherValue && fatherValue) {
          this.getOptions();
        }

        if (
          this.lastFatherValue[dad.fieldKey] != fatherValue &&
          this.lastFatherValue[dad.fieldKey]
        ) {
          this.valueInput = '';
          this.changeValue('');
        }

        this.lastFatherValue[dad.fieldKey] = fatherValue;

        this.optionsParams[dad.fieldKey] = fatherValue;
      });
    }
  }

  @Input('dynamicFormService') set formServiceSetter(dynamicFormService: DynamicFormService) {
    this.dynamicFormService = dynamicFormService;
  }

  @Output('changeLabelValue') changeLabelEmmiter = new EventEmitter();
  @Output('changeValue') changeEmmiter = new EventEmitter();
  @Output('startValue') startValueEmmiter = new EventEmitter();

  @Output('focusState') focusStateEmmiter = new EventEmitter();

  @Output('setError') setErrorEmmiter = new EventEmitter();

  @Output('errorApi') errorApiEmmiter = new EventEmitter();
  @Output('feedback') feedbackEmmiter = new EventEmitter();

  @Output('validStatus') setValidEmitter = new EventEmitter();

  private listner = (e: any) => {
    const {
      entityUrl,
      entityParameter,
      entityParameters = {},
      fatherKey,
      formatterResponse,
      actions = [],
      value,
    } = e.detail;

    if (value) this.valueInput = value;

    if (entityUrl && formatterResponse) {
      const params = {};
      if (typeof entityParameters === 'object' || !Array.isArray(entityParameters)) {
        const keys = Object.keys(entityParameters);

        keys.forEach((key) => {
          params[key] =
            this.dynamicFormService?.formControlStructure?.fieldControl?.[
              entityParameters[key]
            ]?.value;
        });
      }

      if (entityParameter) {
        params[entityParameter] =
          this.dynamicFormService?.formControlStructure?.fieldControl?.[fatherKey]?.value;
      }

      this.formTemplateService
        .getDinamicUrl<string[]>(entityUrl, params)
        .subscribe((data: string[]) => {
          const responseFormated = {};

          Object.keys(formatterResponse).forEach((key) => {
            if (formatterResponse[key].type === 'primitive')
              responseFormated[key] = formatterResponse[key].value;
            if (formatterResponse[key].type === 'fromResponse')
              responseFormated[key] = data[formatterResponse[key].key];
          });

          actions.forEach((action) => {
            if (action === 'setSearchValue') this.searchValue([responseFormated]);
          });
        });
    }

    this.getOptions();
  };

  ngOnInit() {
    if (this.field.entityKey) {
      window.addEventListener(`reload_${this.field.entityKey}`, this.listner, false);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['setIsOpen']?.currentValue && !!this.valueInput) {
      const val = this.valueInput;

      if (val.data) {
        val.data = val.data.map((item) => item?.id ?? item);

        this.processInputValue(val).then((value) => {
          if (val.data) {
            this.valueInput = {
              primary: val.primary,
              data: value,
            };
            this.setValidEmitter.emit(true);
          } else {
            this.valueInput = value;
          }
        });
      }
    }
  }

  ngOnDestroy(): void {
    window.removeEventListener(`reload_${this.field.entityKey}`, this.listner, false);
  }

  setValidControllEmmiter($event) {
    this.setValidEmitter.emit($event);
  }

  public setDynamicForm($event): void {
    this.callDynamicForm.emit($event);
  }

  private getOptions() {
    if (this.getIntervalOptions) clearTimeout(this.getIntervalOptions);
    if (this.field.auxEntity.listOptions) {
      this.options = this.field.auxEntity.listOptions.map((item) => ({
        id: item.value,
        label: item.label,
      }));
      this.loading = true;
    } else if (!this.field.auxEntity.entityUrl) {
      // sem entityUrl não há rota para buscar as opções; o campo aparece vazio
      this.options = [];
      this.loading = true;
    } else {
      this.getIntervalOptions = setTimeout(() => {
        const {
          entityUrl,
          entityId,
          entityAttribute = null,
          isEntityPagination = false,
          isEntitySearchable = false,
          isEntityGraphql = false,
          graphQlObject,
          tableName = false,
          esIndex,
          esSearchKeys,
          isDependent,
          fatherKey,
          entityParameter,
          index,
          indexUri = null,
          entityParameters,
          isMetaData,
          customParameters,
        } = this.field.auxEntity;

        if (!esIndex) {
          if (isDependent) {
            const params: any = {};

            params.tableName = tableName;

            if (typeof entityParameters === 'object' && !Array.isArray(entityParameters)) {
              const keys = Object.keys(entityParameters);

              keys.forEach((key) => {
                params[key] =
                  this.dynamicFormService?.formControlStructure?.fieldControl?.[
                    entityParameters[key]
                  ]?.value;

                if (key === 'filters') {
                  const filter = {};
                  for (const k in entityParameters.filters) {
                    if (typeof entityParameters.filters[k] === 'object') {
                      filter[k] = {
                        value:
                          this.dynamicFormService?.formControlStructure?.fieldControl?.[
                            entityParameters.filters[k]?.value
                          ]?.value,
                        op: entityParameters.filters[k]?.op ?? '=',
                      };
                    } else {
                      filter[k] =
                        this.dynamicFormService?.formControlStructure?.fieldControl?.[
                          entityParameters.filters[k]
                        ]?.value;
                    }
                  }
                  params.filters = JSON.stringify(filter);
                }
              });
            }

            if (entityParameter) {
              params[entityParameter] =
                this.dynamicFormService?.formControlStructure?.fieldControl?.[fatherKey]?.value;
            }

            this.getEntityMicro(
              entityUrl,
              entityId,
              entityAttribute,
              isEntitySearchable,
              isEntityPagination,
              params
            );
          } else {
            if (tableName) {
              const params = {};
              if (entityParameter && fatherKey)
                params[entityParameter] = isMetaData
                  ? this.dynamicFormService.formControlStructure?.formMetadata?.[fatherKey]
                  : this.dynamicFormService?.formControlStructure?.fieldControl?.[fatherKey]?.value;

              if (entityParameter && !fatherKey) {
                if (!this.valueInput) return;
                params[entityParameter] = this.valueInput;
              }

              this.getTaskDropData(entityUrl, tableName, params);
            } else if (customParameters) {
              this.getTaskDropData(entityUrl, undefined, customParameters);
            } else {
              const params = {
                [entityParameter]: this.optionsParams[fatherKey],
              };

              this.getEntityMono(
                entityUrl,
                entityId,
                entityAttribute,
                isEntitySearchable,
                isEntityPagination,
                params
              );
            }
          }
        } else {
          this.getEntityEs(entityUrl, esIndex, esSearchKeys, index);
        }
      }, 10);
    }
  }

  private async processInputValue(val: any): Promise<any> {
    const {
      entitySelectedRecoverUrl = null,
      entityId,
      isEntityGraphql = false,
      graphQlObject,
      index,
      filter,
    } = this.field.auxEntity;

    if (entitySelectedRecoverUrl && !isEntityGraphql) {
      return await this.getSelectedRecover(entitySelectedRecoverUrl, entityId, val, index);
    } else if (entitySelectedRecoverUrl && isEntityGraphql) {
      return await this.getSelectRecoveryEntityGraphql(
        entitySelectedRecoverUrl,
        val,
        graphQlObject,
        index,
        filter
      );
    }
    return val;
  }

  private getSelectedRecover(
    entitySelectedRecoverUrl,
    entityId,
    arrayIds,
    index
  ): Promise<Array<any>> {
    const params: any = { entityIdList: arrayIds, entityId, index };

    this.cursorAwaitAdd();

    return new Promise((resolve, reject) => {
      this.formTemplateService.getDinamicUrl(entitySelectedRecoverUrl, params).subscribe(
        (resp: any) => {
          if (resp.code == 200) {
            const { data } = resp;
            resolve(data);
          } else {
            reject(resp);
            this.errorApiEmmiter.emit(resp);
          }
        },
        (error: any) => {
          reject(error);
          this.errorApiEmmiter.emit(error);
        },
        () => this.cursorAwaitRemove()
      );
    });
  }

  private getEntityEs(entityUrl, indexEs, esSearchKeys, index) {
    const keysToReceive: any[] = [];
    this.field.configuration.primary.forEach((element) => {
      keysToReceive.push(element.entityKey);
    });
    this.isSearch = false;

    keysToReceive.push('id');

    this.loading = true;

    if (isEmptyRamda(this.searchFilter)) {
      this.options = [];
      return;
    }

    let params = {};
    if (typeof this.searchFilter === 'object') {
      // Quando a pesquisa for por TAGS

      params = {
        idx: index,
        extraFields: JSON.stringify(this.searchFilter),
        returnFields: JSON.stringify(keysToReceive),
        sourceFields: JSON.stringify(esSearchKeys),
        page: this.pageSelected,
        capabilityName: 'base/home',
        size: 5,
      };
    } else {
      params = {
        idx: index, // troquei o indexEs para index para a historia 1939 sprint 20
        search: this.searchFilter + '*',
        returnFields: JSON.stringify(keysToReceive),
        sourceFields: JSON.stringify(esSearchKeys),
        page: this.pageSelected,
        capabilityName: 'base/home',
        size: 5,
      };
    }
    // this.pageSelected

    this.cursorAwaitAdd();

    this.formTemplateService.getDinamicUrl(entityUrl, params).subscribe(
      (resp: any) => {
        let arrayFiltered = resp ? resp.data : [];
        this.totalPages = resp ? Math.ceil(resp.total / 5) : 0;

        if (
          arrayFiltered &&
          arrayFiltered.length > 0 &&
          this.exclusionIdsList &&
          this.exclusionIdsList.length > 0
        ) {
          this.exclusionIdsList.forEach((item) => {
            arrayFiltered = arrayFiltered.filter((element) => element.id !== item);
          });
        }

        this.cursorAwaitRemove();
        this.isSearch = true;
        this.options = arrayFiltered;
      },
      (error: any) => {
        this.errorApiEmmiter.emit(error);
      }
    );
  }

  public setFeedbackEmmiter(feedback) {
    this.feedbackEmmiter.emit(feedback);
  }

  private getSelectRecoveryEntityGraphql(
    entitySelectedRecoverUrl,
    val,
    graphQlObject,
    index,
    filter
  ) {
    const keys = this.field.configuration.primary.map((element) => element.entityKey);
    const ids = val.data ? JSON.stringify(val.data) : JSON.stringify(val);

    const paramns = {
      ids,
      returnFields: JSON.stringify(keys),
      index,
      flowId: this.flowId,
      filter: JSON.stringify(filter),
    };

    return new Promise((resolve, reject) => {
      this.formTemplateService
        .getDinamicUrl(entitySelectedRecoverUrl, paramns)
        .subscribe((resp: any) => {
          resolve(resp);
        });
    });
  }

  private getEntityMono(
    entityUrl,
    entityId,
    entityAttribute,
    isEntitySearchable,
    isEntityPagination,
    entityParam: any = null
  ) {
    let params: any = { entityId: entityId, flowId: this.flowId };

    if (entityAttribute) params.entityAttribute = entityAttribute;

    if (isEntityPagination) {
      params.page = this.pageSelected;
      params.pageSize = 5;
    }

    if (isEntitySearchable) {
      params.attributeFilterValue = this.searchFilter ? this.searchFilter : '';
    }

    if (this.exclusionIdsList.length > 0 && isEntityPagination) {
      params.idExclusionList = this.exclusionIdsList;
    }

    if (entityParam) {
      params = { ...params, ...(entityParam as object) };
    }

    this.cursorAwaitAdd();

    this.formTemplateService.getDinamicUrl(entityUrl, params).subscribe(
      (resp: any) => {
        this.cursorAwaitRemove();

        if (Array.isArray(resp)) (this.options as any) = resp;
        if (resp.code == 200) {
          const data = resp.data.data ? resp.data.data : resp.data;
          if (isEntityPagination) {
            this.totalPages = resp.data.totalPages;
          }

          if (entityAttribute) {
            if (data.length > 0) {
              this.options = data.map((item) => ({
                id: item.id,
                label: item[this.field.auxEntity.entityAttribute],
              }));
            }
          } else {
            this.options = data;
          }
        } else {
          this.errorApiEmmiter.emit(resp);
        }
      },
      (error: any) => {
        this.errorApiEmmiter.emit(error);
      },
      () => (this.loading = true)
    );
  }

  private getTaskDropData(entityUrl, tableName, params: any = {}) {
    // let params: any = { tableName };
    params.tableName = tableName;
    params.flowId = this.flowId;
    if (this.cardInfo && this.cardInfo.flowId) params['flowId'] = this.cardInfo.flowId;

    this.formTemplateService.getDinamicUrl(entityUrl, params).subscribe(
      (resp: any) => {
        if (!resp) this.options = [];
        else {
          if (Array.isArray(resp))
            (this.options as any) = resp.map((item) => ({
              id: tableName == 'legal-request-indexes' ? item.path : item.id,
              label: this.field.auxEntity.entityAttribute
                ? item[this.field.auxEntity.entityAttribute]
                : item.label,
            }));
          else (this.options as any) = [resp];
        }
      },
      (error: any) => {
        this.errorApiEmmiter.emit(error);
      },
      () => {
        this.loading = true;
      }
    );
  }

  private getEntityMicro(
    entityUrl,
    entityId,
    entityAttribute,
    isEntitySearchable,
    isEntityPagination,
    entityParam: any = null
  ) {
    let params: any = { entityId: entityId, flowId: this.flowId };

    if (entityAttribute) params.entityAttribute = entityAttribute;

    if (isEntityPagination) {
      params.page = this.pageSelected;
      params.pageSize = 5;
    }

    if (isEntitySearchable) {
      params.attributeFilterValue = this.searchFilter ? this.searchFilter : '';
    }

    if (this.exclusionIdsList.length > 0 && isEntityPagination) {
      params.idExclusionList = this.exclusionIdsList;
    }

    if (entityParam) {
      params = { ...(entityParam as object), flowId: this.flowId };
    }

    this.cursorAwaitAdd();

    this.formTemplateService
      .getDinamicUrl(entityUrl, params)
      .pipe(finalize(() => this.cursorAwaitRemove()))
      .subscribe(
        (resp: any) => {
          if (resp) {
            const data = resp.data ? resp.data : resp;

            if (isEntityPagination) {
              this.totalPages = resp.data.totalPages;
            }
            if (entityAttribute) {
              if (Array.isArray(data)) {
                this.options = data.map((item) => ({
                  id: item.id,
                  label: item[this.field.auxEntity.entityAttribute],
                }));
                if (data.length === 0) this.errorApiEmmiter.emit('Empt-Error');
              } else {
                this.options = [data];
              }
            } else {
              if (Array.isArray(data)) this.options = data;
              else (this.options as any) = [data];
            }
          }
        },
        (error: any) => {
          this.errorApiEmmiter.emit(error);
        },
        () => (this.loading = true)
      );
  }

  public selectedValuesWhitExclusion(value: any) {
    this.exclusionIdsList = value;
    if (value.data) this.exclusionIdsList = value.data;
    const { entityUrl, esIndex = 'people' } = this.field.auxEntity;

    if (esIndex) this.options = [];

    this.changeValue(value);
    // this.getOptions(); // retirando recarga de dados pos selecao ou remocao
  }

  public selectedPage(value: number): void {
    this.pageSelected = value - 1;
    this.getOptions();
  }

  public searchValue(value: any): void {
    this.searchFilter = value;
    this.getOptions();
  }
}
